import React from 'react';
import { TasksWidget } from './Widgets/TasksWidget';
import { ServiceRequestWidget } from './Widgets/ServiceRequestWidget';
import { QuickAccessWidget } from './Widgets/QuickAccessWidget';
import { LandPropertyWidget } from './Widgets/LandPropertyWidget';
import { TaxesRevenueWidget } from './Widgets/TaxesRevenueWidget';
import { BusinessLicensingWidget } from './Widgets/BusinessLicensingWidget';
import { WasteManagementWidget } from './Widgets/WasteManagementWidget';
import { WaterSanitationWidget } from './Widgets/WaterSanitationWidget';
import { InfrastructureWidget } from './Widgets/InfrastructureWidget';
import { PublicSafetyWidget } from './Widgets/PublicSafetyWidget';
import { CivilRegistryWidget } from './Widgets/CivilRegistryWidget';
import { SystemOverviewWidget } from './Widgets/SystemOverviewWidget';
interface DashboardProps {
  userRole: string;
}
export const Dashboard = ({
  userRole
}: DashboardProps) => {
  return <div className="p-6" data-id="element-256">
      <div className="mb-6" data-id="element-257">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-258">Dashboard</h1>
        <p className="text-sm text-gray-500" data-id="element-259">
          Welcome back, here's your overview for today
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-260">
        {/* Primary widgets - always shown */}
        <div className="lg:col-span-2" data-id="element-261">
          <TasksWidget data-id="element-262" />
        </div>
        <div data-id="element-263">
          <ServiceRequestWidget data-id="element-264" />
        </div>
        <div className="lg:col-span-3" data-id="element-265">
          <QuickAccessWidget data-id="element-266" />
        </div>
        {/* Service category widgets */}
        <div data-id="element-267">
          <LandPropertyWidget data-id="element-268" />
        </div>
        <div data-id="element-269">
          <TaxesRevenueWidget data-id="element-270" />
        </div>
        <div data-id="element-271">
          <BusinessLicensingWidget data-id="element-272" />
        </div>
        <div data-id="element-273">
          <WasteManagementWidget data-id="element-274" />
        </div>
        <div data-id="element-275">
          <WaterSanitationWidget data-id="element-276" />
        </div>
        <div data-id="element-277">
          <InfrastructureWidget data-id="element-278" />
        </div>
        <div data-id="element-279">
          <PublicSafetyWidget data-id="element-280" />
        </div>
        <div data-id="element-281">
          <CivilRegistryWidget data-id="element-282" />
        </div>
        {/* Admin specific widgets */}
        {userRole === 'Municipal Administrator' && <div className="lg:col-span-3" data-id="element-283">
            <SystemOverviewWidget data-id="element-284" />
          </div>}
      </div>
    </div>;
};